import React, { Component } from "react";

export default class TxtViewerClass extends Component {

detecterTypeLigne(texte) {
  const ligne = texte.trim();

  // 1) Cas : numéro + timestamps
  if (/^\d+\)\s*\d{2}:\d{2}:\d{2}\.\d{3}\s+\d{2}:\d{2}:\d{2}\.\d{3}$/.test(ligne)) {
    return "tc";
  }

  // 2) Cas : seulement timestamps
  if (/^\d{2}:\d{2}:\d{2}\.\d{3}\s+\d{2}:\d{2}:\d{2}\.\d{3}$/.test(ligne)) {
    return "tc";
  }

  // 3) Cas : seulement numéro
  if (/^\d+\)$/.test(ligne)) {
    return "tc";
  }

  // 4) Cas : vide
  if (ligne === "") {
    return "empty";
  }

  // 5) Tout le reste
  return "other";
}

  render() {
    const { text } = this.props;
    var render=[];
    const timeStyle = { color: "#58a6ff", fontWeight: "bold"};
    const textStyle = { color: "#dcdcdc", whiteSpace: "pre-line" }; // <-- conserve les \n visuellement

    const lines = text.split(/\r?\n/);
    lines.forEach((line,i) => {
      switch(this.detecterTypeLigne(line))
      {
      case "tc":
        render.push (
          <div key={i} style={{ marginBottom: "0.2rem" }}>
            <span style={timeStyle}>{line}</span>
          </div>
        )
        break;
      case "empty":
        render.push (
          <div key={i} style={{ marginBottom: "0.95rem" }}>

          </div>
        )
        break;
      case "other":
        render.push (
          <div key={i} style={{ marginBottom: "0rem" }}>
            <span style={textStyle}>{line}</span>
          </div>
        )
        break;
      }
      
    });

    const containerStyle = {
      background: "#0d1117",
      color: "#c9d1d9",
      paddingLeft: "10px",
      fontFamily: "JetBrains Mono, Fira Code, monospace",
    };


    return (
      <div style={containerStyle}>
        {render}
      </div>
    );
  }
}
